import path from "path";

export const LINKS = {
  login: (isExport = false) =>
    `/${path.join(isExport ? "export" : "", "login")}`,
  contractPrivate: isExport =>
    `/${path.join(isExport ? "export" : "", "private", "contract")}`,
  contractTesla: isExport =>
    `/${path.join(isExport ? "export" : "", "private", "tesla")}`
};
